export default {
	// Custom Page Meta
	seo_meta_title_leaguepass: 'League Pass – 直播串流 NBA 賽事 | NBA.com',
	seo_meta_desc_leaguepass: '透過 League Pass，直播或隨選串流 NBA 賽事。在此使用您的帳戶。',
	seo_meta_keywords_leaguepass: 'NBA 影片, NBA 精華片段, 籃球影片, 精彩好球, 灌籃, 呈獻',
	seo_meta_title_featured: '串流 NBA 賽事及觀看賽事精華 | NBA.com',
	seo_meta_desc_featured: '免費觀看 NBA 影片精華、新聞、分析報導。此外，還可探索 NBA TV 和 League Pass 訂閱內容，並用您最愛的裝置直播觀看賽事。',
	seo_meta_keywords_featured: '',
	seo_meta_title_nbatv: 'NBA TV - 直播串流賽事及全天候報導內容 | NBA.com',
	seo_meta_desc_nbatv: '直播串流 NBA TV 上的賽事內容，或觀看人氣歷久不衰的經典賽事。此外，還可收看工作室節目及整個聯盟相關的分析報導。',
	seo_meta_keywords_nbatv: 'NBA TV 頻道, the beat, hardwood classics, nba live, real nba, nba gametime, fantasy insider, 攝影棚節目, the jump',
	seo_meta_title_classicgames: '用 NBA TV 串流觀看經典賽事和更多豐富內容 | NBA.com',
	seo_meta_desc_classicgames: '透過 NBA TV 串流觀看經典的 NBA 對戰賽事。此外，還能直播串流 NBA TV 上的賽事內容，同時收看工作室節目及整個聯盟相關的分析報導。',
	seo_meta_keywords_classicgames: '',
	seo_meta_pre_title_videolist: '在此串流相關內容 | NBA.com',
	seo_meta_title_videolist: '在此串流 {0} | NBA.com',
	seo_meta_desc_videolist: '在此觀看 {0} 影片。此外，還可探索 NBA TV 和 League Pass 訂閱內容，並用您最愛的裝置觀看直播賽事。',
	seo_meta_title_videolist_show: '用 NBA TV 串流{0} | NBA.com',
	seo_meta_desc_videolist_show: '在此觀看{0}。此外，還可直播串流 NBA TV 賽事內容，並收看經典賽事和分析報導。',
	seo_meta_keywords_videolist_show: '',
	seo_meta_title_videolist_feed: '在此串流{0} | NBA.com',
	seo_meta_desc_videolist_feed: '在此觀看 {0} 影片。此外，還可探索 NBA TV 和 League Pass 訂閱內容，並用您最愛的裝置觀看直播賽事。',
	seo_meta_keywords_videolist_feed: '',
	seo_meta_keywords_videolist: '',
	seo_meta_title_shows: '用 NBA TV 串流觀看工作室節目和更多豐富內容 | NBA.com',
	seo_meta_desc_shows: '探索並隨選串流最新的 NBA TV 節目和相關集數。此外，還可直播串流 NBA TV 賽事內容，同時收看經典賽事及分析報導。',
	seo_meta_keywords_shows: '',
	// Common Page Meta
	seo_meta_title_home: '首頁 | NBA.com',
	seo_meta_desc_home: '',
	seo_meta_keywords_home: '',
	seo_meta_title_channels: '頻道 | NBA.com',
	seo_meta_desc_channels: '',
	seo_meta_keywords_channels: '',
	seo_meta_pre_title_channel: '頻道 | NBA.com',
	seo_meta_pre_title_categories: '類別 | NBA.com',
	seo_meta_title_categories: '類別 | NBA.com',
	seo_meta_desc_categories: '',
	seo_meta_keywords_categories: '',
	seo_meta_pre_title_category: '類別 | NBA.com',
	seo_meta_title_category: '類別 | NBA.com',
	seo_meta_desc_category: '',
	seo_meta_keywords_category: '',
	seo_meta_pre_title_video: '在此串流影片 | NBA.com',
	seo_meta_pre_title_event: '在此串流活動內容 | NBA.com',
	seo_meta_title_events: '活動 | NBA',
	seo_meta_desc_events: '',
	seo_meta_keywords_events: '',
	seo_meta_title_event: '在此串流{0} | NBA.com',
	seo_meta_desc_event: '在此觀看{0}。此外，還可探索 NBA TV 和 League Pass 訂閱內容，並用您最愛的裝置觀看直播賽事。',
	seo_meta_keywords_event: '',
	seo_meta_title_search: '搜尋 | NBA.com',
	seo_meta_desc_search: '',
	seo_meta_keywords_search: '',
	seo_meta_title_notfound: '找不到頁面 | NBA.com',
	seo_meta_desc_notfound: '',
	seo_meta_keywords_notfound: '',
	seo_meta_pre_title_game: '在此串流賽事內容 | NBA.com',
	seo_meta_title_game: '在此串流{0} | NBA.com',
	seo_meta_desc_game: '在此觀看{0}。此外，還可探索 NBA TV 和 League Pass 訂閱內容，並用您最愛的裝置觀看直播賽事。',
	seo_meta_keywords_game: '',
	seo_meta_title_video: '在此串流{0} | NBA.com',
	seo_meta_desc_video: '在此觀看{0}。此外，還可探索 NBA TV 和 League Pass 訂閱內容，並用您最愛的裝置觀看直播賽事。',
	seo_meta_keywords_video: 'NBA 影片, NBA 精華片段, 籃球影片, 精彩好球, 灌籃, 呈獻',
	seo_meta_title_episode: '用 NBA TV 串流{0} | NBA.com',
	seo_meta_desc_episode: '在此觀看{0}。此外，還可直播串流 NBA TV 賽事內容，並收看經典賽事和分析報導。',
	seo_meta_keywords_episode: 'NBA 影片, NBA 精華片段, 籃球影片, 精彩好球, 灌籃, 呈獻',
	seo_meta_title_channel: 'NBA TV 直播賽事 | NBA.com',
	seo_meta_desc_channel: 'NBA TV Live 是您全天無休的 NBA TV 頻道，每周皆有現場直播及錄影轉播 NBA 賽事可供觀看，另外還提供攝影棚節目與球評分析',
	seo_meta_keywords_channel: 'NBA TV 頻道, the beat, hardwood classics, nba live, real nba, nba gametime, fantasy insider, 攝影棚節目, the jump',
	seo_meta_title_tvguide: 'NBA TV 直播串流時間表 | NBA.com',
	seo_meta_desc_tvguide: '查看何時可在您最愛的裝置上用 NBA TV 直播串流 NBA TV 賽事和直播的工作室節目。此外，還可隨選點播收看工作室節目及分析報導。',
	seo_meta_keywords_tvguide: 'NBA TV 頻道, the beat, hardwood classics, nba live, real nba, nba gametime, fantasy insider, 攝影棚節目, the jump',

	// Common
	timezone: 'ET',
	default_feed_error_message: '系統發生問題，目前無法提供相關內容。請稍後再試一次。',
	watch_in_app: '在 NBA 應用程式上觀看',
	ad_blocked_message: '偵測到廣告攔截程式：NBA.com 內容由廣告商提供相關支援。如要繼續享有精彩賽事內容，請關閉您的廣告攔截程式。',

	// Item
	no_content: '無任何內容',
	see_more: '查看更多',
	now_playing: '現正播放',
	nba_tv_lock: 'NBA TV',
	league_pass_lock: 'League Pass',
	league_pass_premium_lock: 'LP PREMIUM',
	error_max_limit_favorite: '您的最愛影片數量已達到上限，若要加入更多影片，請先移除部分最愛影片。',
	item_live: '現場直播',
	add_favourite_title: '加到我的最愛',
	remove_favourite_title: '從我的最愛移除',
	// Channel: Schedule
	p_channel_live: '現場直播',
	p_channel_schedule_title: 'NBA TV 賽程',
	p_channel_schedule_watch: '觀看',
	p_channel_live24x7_title: 'NBA TV 全年無休',
	p_channel_live24x7_see_full_schedule: '查看完整的賽程',
	p_channel_live24x7_up_next: '緊接在後',
	p_channel_live24x7_on_demand: 'NBA TV：隨選內容',
	p_channel_live24x7_collection: '集錦',
	p_channel_live24x7_demand_1_logo_text: '原創節目',
	p_channel_live24x7_demand_1_show_name: 'NBA TV 節目',
	p_channel_live24x7_demand_1_show_desc: '原創 NBA TV 節目，包括《俠客的五大好糗》、《Beyond the Paint》、《Game Time》和《籃球故事》',
	p_channel_live24x7_demand_2_logo_text: '經典賽事',
	p_channel_live24x7_demand_2_show_name: 'NBA | 經典賽事',
	p_channel_live24x7_demand_2_show_desc: '觀看整場經典賽事，包括自 2000 年以來所有總決賽大對決、精彩萬分的聯盟時刻，以及傳奇性球員英姿',

	// Channel: Clips
	p_channel_error_msg: '還不能使用',

	// Channel: detail
	p_channel_category_title: 'NBA TV',
	p_channel_playlist_title: '賽程',

	// NBA TV Shows:
	p_nba_tv_shows: 'NBA TV 節目',
	p_nba_tv_no_access_title: '全年無休的 NBA：隨時掌握賽事分析、工作室剖析、原創節目等精彩內容！',
	p_nba_tv_no_access_desc: '觀看直播賽事，並隨選點播其他節目和經典賽事。',
	p_nba_tv_no_access_note: '可能會有播出限制',

	// tv show item
	tv_show_item_latest_episode: '最新一集',
	tv_show_item_no_latest_episode: '沒有最新集數',
	see_all: '查看全部',
	// header
	header_menu_watch: '觀看',
	header_menu_featured: '精選',
	header_menu_nba_tv: 'NBA TV',
	header_menu_league_pass: 'League Pass',

	// Search
	players: '球員',
	videos: '影片',
	teams: '球隊',
	most_searched: '熱門搜尋',
	no_result: '無任何資料',
	search_filter_type_most_relevant: '最相關',
	search_filter_type_most_viewed: '最多人觀賞',
	search_filter_type_most_recent: '最近期',
	search_filter_type_last_30_days: '過去 30 天',
	search_filter_type_last_6_months: '過去 6 個月',
	search_result_label: '「{keyword}」的搜尋結果',
	search_result_info: '查看所有「{keyword}」的搜尋結果',
	search_placeholder: '搜尋影片庫',
	load_more: '載入更多...',

	// button
	button_subscribe: '訂閱',
	button_sign_in: '登入',
	button_tv_provider: '選取電視節目供應商',

	// league page
	p_league_pass_no_access_title: '透過任何裝置觀看直播賽事或重播比賽，想用電腦、智慧型手機或電視觀賽都沒問題！',
	p_league_pass_no_access_desc: '取得精彩賽事入場券：觀看整個聯盟或愛隊的英姿、選看單場比賽，或查看其他更多選項。',
	p_league_pass_no_access_note: '適用相關條款',

	// Video
	category_title: '影片',
	p_video_playlist_title: '播放清單：',
	p_video_episode_text: '集數',
	p_no_access_league_pass_title: '解鎖 NBA League Pass 以觀看：',
	p_no_access_league_pass_premium_title: 'Unlock NBA League Pass Premium to watch:',
	p_no_access_league_pass_desc: '取得精彩賽事入場券：觀看整個聯盟或愛隊的英姿、選看單場比賽，或查看其他更多選項。',
	p_no_access_league_pass_terms: '適用相關條款',
	p_no_access_league_pass_geo_desc: '根據您目前的位置，您無法透過 NBA League Pass 和 NBA TV 觀看這場比賽。錄影賽事影片將在轉播後的 3 天，供 NBA League Pass 訂戶觀看。請洽詢您當地的電視或廣電業者，確認賽事播放的時間表。',
	p_no_access_league_pass_not_found_desc: '抱歉，找不到您要查詢的影片。',
	p_no_access_event_geo_desc: '此場轉播賽事無法提供給美加地區的球迷觀看。如要觀賽，美國的觀眾請鎖定 ESPN，而加拿大的觀眾請鎖定 TSN 或 Sportsnet。',
	p_no_access_event_not_found_desc: '抱歉，找不到您要查詢的活動。',
	p_no_access_nba_tv_title: '解鎖 NBA TV 以觀看：',
	p_no_access_nba_tv_desc: '觀看直播賽事，並隨選點播其他節目和經典賽事。',
	p_no_access_nba_tv_terms: '適用相關條款',
	p_no_access_nba_tv_geo_desc: '根據您目前的位置，您無法透過 NBA League Pass 和 NBA TV 觀看這場比賽。錄影賽事影片將在轉播後的 3 天，供 NBA League Pass 訂戶觀看。請洽詢您當地的電視或廣電業者，確認賽事播放的時間表。',
	p_no_access_nba_tv_not_found_desc: '抱歉，找不到您要查詢的頻道。',
	p_no_access_up_next: '緊接在後：',
	p_video_completed_title: '播放清單完成',
	p_video_completed_desc: '返回瀏覽，或查看您的下一個播放清單',
	p_video_share_to: '分享至：',
	p_video_more_to_watch: '更多觀看內容：',

	// Event
	p_event_section_title: '節目',
	p_event_playlist_title: '播放清單：',
	p_event_button_watch: '觀看',
	p_event_button_listen: '收聽',
	p_event_button_ticket: '票券',

	// notfound page
	notfound: '抱歉，找不到您要的頁面。',
	notfound_desc: '請檢查 URL 是否有誤。<br/>您也可以嘗試使用網站導覽或搜尋工具來尋找您要的內容。',

	// Modal - PCM
	modal_pcm_header_title: '',
	modal_pcm_body_title: '',
	modal_pcm_body_description: '您的 NBA League Pass 帳戶已達串流上限。點選「繼續」以繼續在此裝置上收看。',
	modal_pcm_custom: '繼續',
	modal_pcm_close: '取消',
	modal_pcm_ok: '確定',

	// Modal - Unsupported
	modal_video_unsupported_header_title: '',
	modal_video_unsupported_body_title: '',
	modal_video_unsupported_body_description: '這部影片無法在您的裝置上播放。<a href=\'https://neulion-a.akamaihd.net/nlweb/h5support/player.html\' target=\'_blank\'>點此</a>取得相關協助。',
	modal_video_unsupported_custom: '',
	modal_video_unsupported_close: '確定',
	modal_video_unsupported_ok: '確定',

	// FreeSample
	freesample_notice_time: '剩餘時間',
	freesample_notice_title: '享受你的 {0} 分鐘權限',
	freesample_notice_desc: '訂閱完整的 League Pass 套餐，在 {0} 分鐘結束後繼續存取內容。',
	freesample_notice_subscribe_button: '訂閱',
	freesample_notice_cancel_button: '隨時取消',
	freesample_popup_title: '你的權限已結束',
	freesample_popup_subtitle: '訂閱 League Pass，觀看更多 NBA 精彩內容。',
	freesample_popup_link: '進一步瞭解',
	freesample_popup_get_minutes_button: '取得 {0}  分鐘',

	// Video list
	reg_required_desc: '您必須先登入才能查看此內容',
	favorite_teams_title: '最愛球隊',
	bookmarked_title: '已儲存',
	watch_history_title: '繼續觀看',
	game_schedule_title: '比賽賽程',
	recommended_title: '推薦',
	season_text: '賽季',

	// profile page
	section_information_title: '我的資訊',
	section_information_desc: '更新您的個人資訊',
	section_information_email: '電子郵件',
	section_information_email_update: '更新電子郵件地址',
	section_information_password: '密碼',
	section_information_password_update: '變更密碼',
	section_information_social: '社交連結',
	section_information_nosocial_message: '您沒有已連結的帳戶。',
	section_information_firstname: '名字',
	section_information_lastname: '姓氏',
	section_information_birth: '出生日期',
	section_information_country: '國家/地區',
	section_information_postalcode: '郵遞區號',
	section_information_edit: '編輯',
	section_tv_provider_title: '我的電視節目供應商',
	section_tv_provider_desc: '取得權限，觀看您電視節目供應商提供的直播賽事和串流內容。',
	section_tv_provider_faq: '電視節目供應商常見問題',
	section_tv_provider_sign_out: '登出',
	section_tv_provider_sign_in: '登入電視節目供應商系統',
	section_fantasy_title: '場邊花絮',
	section_fantasy_desc: '查看您夢寐以求的帳戶資訊',
	section_fantasy_displayname: '顯示名稱',
	section_marketing_title: '電子郵件偏好設定',
	section_marketing_desc: '查看您的行銷內容及使用者隱私偏好設定',
	section_marketing_newsletters: '電子報',
	section_marketing_message: 'NBA 訊息和廣告內容',
	section_marketing_newsletters_desc_1: '每天發送至您收件匣的 NBA 新聞',
	section_marketing_newsletters_desc_2: 'NBA 官方的較小聯盟 NBA G 聯盟新聞和焦點',
	section_marketing_newsletters_desc_3: 'Jr. NBA 新聞和 NBA 少年籃球倡議相關內容',
	section_marketing_newsletters_desc_4: '最新的 NBA 應用程式功能，外加 League Pass 更新和優惠資訊',
	section_marketing_newsletters_desc_5: 'NBA 專屬票券優惠、合作夥伴優惠、活動和商品折扣',
	section_marketing_newsletters_desc_6: '精選 NBA 新聞及每週發送至您收件匣的相關內容',
	section_marketing_newsletters_desc_7: '由 WNBA 和其合作夥伴提供的新聞和優惠',
	section_marketing_personal_title: '我的個人資訊',
	section_marketing_personal_desc: '請依據我的 NBA 個人資訊發送消息和相關產品廣告，以及 NBA 與 NBA 合作夥伴的計畫。',
	section_marketing_update_button: '更新行銷內容偏好設定',
	section_marketing_update_success: '您的偏好設定已更新。',
	section_ccpa_title: '請勿出售我的個人資訊',

	// profile edit modal
	email_modal_title: '更新電子郵件地址',
	email_modal_new_email_label: '新的電子郵件地址',
	email_modal_update: '更新',
	email_modal_cancel: '取消',
	password_modal_title: '變更密碼',
	password_modal_current_label: '目前密碼：',
	password_modal_new_label: '新密碼：',
	password_modal_confirm_label: '確認密碼：',
	password_modal_update: '更新',
	password_modal_cancel: '取消',
	personal_modal_title: '更新個人資訊',
	personal_modal_email: '電子郵件',
	personal_modal_password: '密碼',
	personal_modal_birth: '出生日期',
	personal_modal_social: '社交連結',
	personal_modal_firstname: '名字',
	personal_modal_lastname: '姓氏',
	personal_modal_country: '國家/地區',
	personal_modal_postalcode: '郵遞區號',
	personal_modal_zipcode: '郵遞區號',
	personal_modal_postalcode_invalid_message: '必須是有效的郵遞區號',
	personal_modal_zipcode_invalid_message: '必須是有效的郵遞區號',
	personal_modal_update: '更新',
	personal_modal_cancel: '取消',

	// payflow
	payflow_profile_name: '姓名',
	payflow_profile_email: '電子郵件',

	// account page
	header_menu_account_my_account: '我的帳戶',
	header_menu_account_manage_account: '管理帳戶',
	header_menu_account_favorite_teams: '最愛球隊',
	header_menu_account_favorite_players: '我最愛的球員',
	header_menu_account_viewing_history: '觀看記錄',
};
